import { Grid } from '@material-ui/core';
import DataType from '@opsbase/lib-datatype/DataType/DataType';
import Pages from '@opsbase/lib-pages';
import useAssetCreate from '@opsbase/react-gql-hooks/asset/useAssetCreate';
import i18n from '@opsbase/lib-i18n';
import useNewDataActionsContext from '@opsbase/web-ctrl-newdata/useNewDataActions';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import EditableList from '@opsbase/web-editablelist';
import useNav from '@opsbase/web-nav/useNav/useNav';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import React, { useCallback, useState } from 'react';
export function AssetCreateDialog() {
    const [items, setItems] = useState([]);
    const createAsset = useAssetCreate();
    const { raise } = useNotificationActions();
    const { replaceTo, goBack } = useNav();
    const { addItemsToType } = useNewDataActionsContext();
    const handleClickCreate = useCallback(() => raise(Promise.all(items.map(async (item) => createAsset({
        patch: {
            title: item.title,
        },
    }))), i18n.t('asset-created-successful')), [createAsset, items, raise]);
    const handleAfterCreate = useCallback(async (assets) => {
        addItemsToType(DataType.ASSET, assets);
        if (assets.length === 1) {
            replaceTo(Pages.ASSETS_EDIT, { id: assets[0].id });
        }
        else {
            goBack();
        }
    }, [goBack, replaceTo, addItemsToType]);
    return (React.createElement(CreateDialog, { padded: true, onCreate: handleClickCreate, afterCreate: handleAfterCreate, title: i18n.t('create-a-asset') },
        React.createElement(Grid, { container: true, direction: "column" },
            React.createElement(EditableList, { autoSelectIdx: 0, placeholder: i18n.t('enter-name-of-new-asset'), canAddAtBottom: true, canDelete: true, items: items, onChange: setItems }))));
}
export default AssetCreateDialog;
